import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    enabled: true,
    list: [],
    unreadCount: 0,
};

const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        setNotificationsEnabled: (state, action) => {
            state.enabled = action.payload;
        },
        loadNotifications: (state, action) => {
            state.list = action.payload || [];
            state.unreadCount = state.list.filter(n => !n.read).length;
        },
        addNotification: (state, action) => {
            state.list.unshift({
                id: Date.now(),
                ...action.payload,
                read: false,
            });
            state.unreadCount += 1;
        },
        markAsRead: (state, action) => {
            const notif = state.list.find(n => n.id === action.payload);
            if (notif && !notif.read) {
                notif.read = true;
                state.unreadCount -= 1;
            }
        },
        clearNotifications: (state) => {
            state.list = [];
            state.unreadCount = 0;
        },
        resetNotifications: () => initialState
    }
});

export const {
    setNotificationsEnabled,
    loadNotifications,
    addNotification,
    markAsRead,
    clearNotifications,
    resetNotifications,
} = notificationSlice.actions;

export const selectNotificationState = (state) => state.notification;
export const selectNotificationsEnabled = (state) => state.notification.enabled;

export default notificationSlice.reducer;


